import React, { FC, useEffect, useState } from 'react'
import { LocaleCodes } from '../../../constants/localization.constants'
import paginationStaticQuery from './paginationStaticQuery'
import { coreRender } from './utils/builder'
import { getPaginationMicrocopy } from './utils/helper'

type Props = {
  activePage: number
  handleClick: (val: number) => void
  numPagesBeforeEllipses: number
  numPages?: number
  numResultsPerPage?: number
  numResults?: number
  className?: string
  showPageNumbers?: boolean
  customNextText?: string
  customPreviousText?: string
  hrefForPage?: Function | null
  locale?: string | null
  theme?: string | null
}

/*
 * Takes in total number of pages to display or uses total number of elements and divide by
 * number of elements to display per page. Also takes in number of pages to display preceding the ellipses.
 */
const Pagination: FC<Props> = ({
  activePage,
  handleClick,
  numPages,
  numResults,
  numResultsPerPage,
  className,
  showPageNumbers = true,
  customNextText,
  customPreviousText,
  hrefForPage = null,
  locale,
  theme,
}) => {
  const [renderingClientSide, setRenderingClientSide] = useState(false)
  const pageLocale = locale || LocaleCodes.ENGLISH.code
  const dynamicData: any = paginationStaticQuery.paginationMicrocopy() || {}

  useEffect(() => {
    getPaginationMicrocopy(dynamicData, pageLocale, text)
    setRenderingClientSide(true)
  }, [])

  const text = {
    next: 'Next',
    prev: 'Previous',
  }

  let totalPages = 1
  if (numPages) {
    totalPages = numPages
  } else if (numResults && numResultsPerPage) {
    totalPages = Math.ceil(numResults / numResultsPerPage)
  }

  const handleButtonClick = (e: any, val: number) => {
    e.preventDefault()
    if (val < 1 || val > totalPages || val === activePage) {
      return
    }

    if (typeof handleClick === 'function') {
      handleClick(val)
    }
  }

  //* we need to force this re-rendering when we're client side as the urls may have query parameters coming from window.location.search
  if (renderingClientSide) {
    return (
      <div>
        {coreRender(
          className || '',
          theme || 'light',
          activePage,
          hrefForPage,
          handleButtonClick,
          customNextText || '',
          customPreviousText || '',
          text,
          showPageNumbers,
          totalPages
        )}
      </div>
    )
  } else {
    return coreRender(
      className || '',
      theme || 'light',
      activePage,
      hrefForPage,
      handleButtonClick,
      customNextText || '',
      customPreviousText || '',
      text,
      showPageNumbers,
      totalPages
    )
  }
}

export default Pagination
